"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCreateBondMultiOrdersTransaction = exports.mergeBondOrderParamsByPair = exports.sendTxnPlaceHolder = void 0;
const constants_1 = require("../../../constants");
const createBondAndSellToOffers_1 = require("./createBondAndSellToOffers");
const sellStakedBanxToOffers_1 = require("./sellStakedBanxToOffers");
const anchor_1 = require("@project-serum/anchor");
const lodash_1 = require("lodash");
const lodash_2 = require("lodash");
const sendTxnPlaceHolder = () => __awaiter(void 0, void 0, void 0, function* () { return yield Promise.resolve(); });
exports.sendTxnPlaceHolder = sendTxnPlaceHolder;
const mergeBondOrderParamsByPair = ({ bondOrderParams }) => {
    const groupedPairOrderParams = Object.values((0, lodash_2.groupBy)(bondOrderParams, (orderParam) => orderParam.pairPubkey));
    const mergedPairsOrderParams = groupedPairOrderParams.map((orderParams) => orderParams.reduce((acc, orderParam) => (Object.assign(Object.assign({}, acc), { orderSize: acc.orderSize + orderParam.orderSize, spotPrice: (acc.orderSize * acc.spotPrice + orderParam.orderSize * orderParam.spotPrice) /
            (acc.orderSize + orderParam.orderSize) }))));
    return mergedPairsOrderParams;
};
exports.mergeBondOrderParamsByPair = mergeBondOrderParamsByPair;
const makeCreateBondMultiOrdersTransaction = ({ marketPubkey, fraktMarketPubkey, oracleFloorPubkey, whitelistEntryPubkey, bondOrderParams, nftMint, banxStake, connection, wallet, isTest, }) => __awaiter(void 0, void 0, void 0, function* () {
    // const {
    //   fbond: bondPubkey,
    //   collateralBox: collateralBoxPubkey,
    //   fbondTokenMint: bondTokenMint,
    //   instructions: createBondIxns,
    //   signers: createBondSigners,
    //   addressesForLookupTable,
    // } = await fbondFactory.createBondWithSingleCollateralPnft({
    //   accounts: {
    //     tokenMint: new PublicKey(nftMint),
    //     userPubkey: wallet.publicKey,
    //   },
    //   args: {
    //     amountToDeposit: 1,
    //     amountToReturn: amountToReturn,
    //     bondDuration: durationFilter,
    //   },
    //   connection,
    //   programId: BONDS_PROGRAM_PUBKEY,
    //   sendTxn: sendTxnPlaceHolder,
    // });
    const mergedPairsOrderParams = (0, exports.mergeBondOrderParamsByPair)({
        bondOrderParams,
    });
    const sellBondParamsAndAccounts = mergedPairsOrderParams
        .filter((orderParam) => orderParam.orderSize > 0)
        .map((orderParam) => ({
        minAmountToGet: Math.max(Math.floor(orderParam.orderSize * orderParam.spotPrice -
            constants_1.PRECISION_CORRECTION_LAMPORTS -
            Math.floor(Math.random() * 10000)), 0),
        amountToSell: Math.floor(orderParam.orderSize),
        bondOfferV2: new anchor_1.web3.PublicKey(orderParam.pairPubkey),
        assetReceiver: new anchor_1.web3.PublicKey(orderParam.assetReceiver),
    }))
        .filter((sellBondParam) => sellBondParam.amountToSell > 0);
    console.log('sellBondParamsAndAccounts: ', sellBondParamsAndAccounts);
    const sellingBondsIxsAndSignersWithLookupAccounts = !banxStake
        ? yield (0, createBondAndSellToOffers_1.createBondAndSellToOffers)({
            accounts: {
                tokenMint: new anchor_1.web3.PublicKey(nftMint),
                fraktMarket: new anchor_1.web3.PublicKey(fraktMarketPubkey),
                oracleFloor: new anchor_1.web3.PublicKey(oracleFloorPubkey || constants_1.PUBKEY_PLACEHOLDER),
                whitelistEntry: new anchor_1.web3.PublicKey(whitelistEntryPubkey || constants_1.PUBKEY_PLACEHOLDER),
                hadoMarket: new anchor_1.web3.PublicKey(marketPubkey),
                userPubkey: wallet.publicKey,
                protocolFeeReceiver: new anchor_1.web3.PublicKey(constants_1.BONDS_ADMIN_PUBKEY || constants_1.PUBKEY_PLACEHOLDER),
            },
            addComputeUnits: true,
            args: {
                sellBondParamsAndAccounts,
            },
            connection,
            programId: new anchor_1.web3.PublicKey(constants_1.BONDS_PROGRAM_PUBKEY),
            sendTxn: exports.sendTxnPlaceHolder,
        })
        : yield (0, sellStakedBanxToOffers_1.sellStakedBanxToOffers)({
            accounts: {
                banxStake: new anchor_1.web3.PublicKey(banxStake),
                tokenMint: new anchor_1.web3.PublicKey(nftMint),
                fraktMarket: new anchor_1.web3.PublicKey(fraktMarketPubkey),
                oracleFloor: new anchor_1.web3.PublicKey(oracleFloorPubkey || constants_1.PUBKEY_PLACEHOLDER),
                whitelistEntry: new anchor_1.web3.PublicKey(whitelistEntryPubkey || constants_1.PUBKEY_PLACEHOLDER),
                hadoMarket: new anchor_1.web3.PublicKey(marketPubkey),
                userPubkey: wallet.publicKey,
                protocolFeeReceiver: new anchor_1.web3.PublicKey(constants_1.BONDS_ADMIN_PUBKEY || constants_1.PUBKEY_PLACEHOLDER),
            },
            addComputeUnits: true,
            args: {
                sellBondParamsAndAccounts,
            },
            connection,
            programId: new anchor_1.web3.PublicKey(constants_1.BONDS_PROGRAM_PUBKEY),
            sendTxn: exports.sendTxnPlaceHolder,
        });
    const slot = yield connection.getSlot();
    console.log('INITIAL PASSED SLOT: ', slot);
    const combinedAddressesForLookupTable = (0, lodash_1.uniqBy)([
        // ...addressesForLookupTable,
        ...sellingBondsIxsAndSignersWithLookupAccounts.addressesForLookupTable,
    ], (publicKey) => publicKey.toBase58());
    console.log('combinedAddressesForLookupTable: ', combinedAddressesForLookupTable.length);
    const [lookupTableInst, lookupTableAddress] = anchor_1.web3.AddressLookupTableProgram.createLookupTable({
        authority: wallet.publicKey,
        payer: wallet.publicKey,
        recentSlot: slot - 2,
    });
    const extendInstructions = (0, lodash_1.chunk)(combinedAddressesForLookupTable, 20).map((chunkOfAddressesForLookupTable) => anchor_1.web3.AddressLookupTableProgram.extendLookupTable({
        payer: wallet.publicKey,
        authority: wallet.publicKey,
        lookupTable: lookupTableAddress,
        addresses: chunkOfAddressesForLookupTable,
    }));
    const createLookupTableTxn = new anchor_1.web3.Transaction().add(lookupTableInst, extendInstructions[0]);
    const restExtendInstructions = extendInstructions.slice(1, extendInstructions.length);
    const restExtendTransactions = restExtendInstructions.map((extendIx) => new anchor_1.web3.Transaction().add(extendIx));
    return {
        createLookupTableTxn: createLookupTableTxn,
        extendLookupTableTxns: restExtendTransactions,
        createAndSellBondsIxsAndSigners: {
            instructions: [
                // ...createBondIxns,
                ...sellingBondsIxsAndSignersWithLookupAccounts.instructions,
            ],
            signers: [
                // ...createBondSigners,
                ...sellingBondsIxsAndSignersWithLookupAccounts.signers,
            ],
            lookupTablePublicKeys: [
                {
                    tablePubkey: lookupTableAddress,
                    addresses: combinedAddressesForLookupTable,
                },
            ],
        },
    };
});
exports.makeCreateBondMultiOrdersTransaction = makeCreateBondMultiOrdersTransaction;
